import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  form: {
    flex: 1,
    '& div[data-placeholder-show^="true"] + .PlaceHolderText': {
      position: "relative",
      left: "18px",
      top: "-38px",
      pointerEvents: "none",
      "& span": {
        color: "#b7b5b5",
        pointerEvents: "none",
      },
    },
    '& .MuiInputLabel-formControl + div[data-placeholder-show-label^="true"] + .PlaceHolderText':
      { display: "none" },
    '& .MuiInputLabel-formControl.Mui-focused.MuiInputLabel-filled.MuiInputLabel-shrink + div[data-placeholder-show-label^="true"] + .PlaceHolderText':
      {
        display: "inline",
        position: "relative",
        left: "14px",
        top: "-38px",
        pointerEvents: "none",
        "& span": {
          color: "#b7b5b5",
          pointerEvents: "none",
          fontSize: "16px",
          letterSpacing: "0.00938em",
        },
      },
    "& #matin.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input": {
      color: "#b7b5b5",
    },
    "& #apresMidi.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input":
      {
        color: "#b7b5b5",
      },
  },
  errorField: {
    minHeight: 20,
    color: theme.color.red,
    fontSize: 12,
  },
  footerForm: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 20,
  },
  inputFormat: {
    "&.MuiFormControl-root": {
      margin: [10, 0, 0, 0],
      fontFamily: theme.font.workSans,
    },
    "& .MuiInputBase-input": {
      fontFamily: ` ${theme.font.workSans} !important`,
    },
  },
  select: {
    composes: "$inputFormat",
    "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
      transform: "translate(12px, -5px) scale(0.75)",
      background: theme.color.white,
    },
  },
  fieldsRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
    marginTop: 20,
  },
  fieldsColumn: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    marginBottom: 20,
    marginTop: 20,
  },
  thinFieldsRow: {
    composes: "$fieldsRow",
    marginTop: 10,
  },
}));
